import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import BaseLoader from "../../components/ui/BaseLoader";
import CreateEditClient from "../../views/Client/CreateEditClient";
import EntityProfile from "../../views/Client/EntityProfile";
import { getClientById } from "../../services/api/client";

const CreateEditClientPage = () => {
  const { id } = useParams();

  const { data, isPending } = useQuery({
    queryKey: ["client", id],
    queryFn: () => getClientById(id),
    enabled: !!id,
  });

  if (id && isPending) return <BaseLoader isLoading />;
  if (id && data?.data?.parentClientId) return <EntityProfile clientId={id} />;
  return <CreateEditClient />;
};

export default CreateEditClientPage;
